<button
  #btnElement
  (click)="onClick($event)"
  [attr.data-test]="buttonId()"
  [attr.title]="(title() | translate) || null"
  [attr.aria-label]="(title() | translate) || null"
  [attr.aria-expanded]="ariaExpanded()"
  [attr.aria-description]="(ariaDescription() | translate) || null"
  [attr.aria-pressed]="active() || null"
  [attr.aria-busy]="showSpinner() || null"
  [attr.type]="buttonType()"
  [disabled]="disabled()"
  [attr.id]="buttonId() || null"
  [ngClass]="btnCssClasses()"
>
  @if (prependIconClass()) {
    <i class="{{ prependIconClass() }} mr-2"></i>
  }
  @if (showHoverEffect() && category() === 'primary') {
    <div [ngClass]="['wave-1', 'wave--effect', waveCssClass()]"></div>
    <div [ngClass]="['wave-2', 'wave--effect', waveCssClass()]"></div>
  }
  @if (!showSpinner()) {
    <span [style.pointer-events]="disabled() ? 'none' : ''">{{ labelKey() | translate }}</span>
    <ng-content />
  }
  @if (showSpinner()) {
    <span class="loading-spinner"></span>
  }
  @if (appendIconClass()) {
    <i class="{{ appendIconClass() }} ml-2"></i>
  }
</button>
